import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const client = process.env.REACT_APP_CLIENT_NAME === undefined ? 'Multiplan' : process.env.REACT_APP_CLIENT_NAME;

import("../src/assets/css/"+client+".css");

ReactDOM.render(<App />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
